import { Modal } from "./Modal";
import HubSpotForm from "./HubSpotForm";
import { DESIGNATION_MAX_LENGTH } from "../../utils/designation";

const DemoModal = ({
    showDemoModal,
    setShowDemoModal
}) => {

    const handleDemoModalClose = () => {
        setShowDemoModal(false)
    }
    //     onEventScheduled: (e) => handleIsScheduled(e),
    //         [name]: value ? "" : prevErrors[name]

    //         newErrors.name = "Name is required";

    //         newErrors.email = "Email is required";
    //         newErrors.email = "Please enter a valid email";

    //         newErrors.designation = "Designation is required";

    //         newErrors.company_name = "Company name is required";

        

    return (
        <>
        {/* <div class="hs-form-frame" data-region="na1" data-form-id="dde1e0f0-9135-49e3-82ae-de9a39f2f768" data-portal-id="49334692"></div> */}
            {showDemoModal && (
                <Modal modalHandle={handleDemoModalClose}>
                    <div className="w-[700px]">
                    <HubSpotForm showDemoModal={showDemoModal}/>
                    </div>
                    {/* <div className="flex flex-col items-center mt-10 text-secondarytwo gap-3"> <DemoMan className="w-[229px] h-[179px]" /> <div> <p className="font-semibold... */}
                </Modal>
            )}
            {/* <PopupModal url={process.env.REACT_APP_CALENDLY_URL} prefill={{ name: demoDetails?.name, email: demoDetails?.email, // customAnswers: { // a1:... */}
        </>
    );
};

export default DemoModal;
